import React from 'react'

export default function Search() {
    return (
        <div>
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_174_3384)">
                    <path d="M29.9937 34L19.5287 23.5351C17.5624 24.7733 15.2448 25.5 12.75 25.5C5.70775 25.5 0 19.7922 0 12.75C0 5.70775 5.70775 0 12.75 0C19.7922 0 25.5 5.70775 25.5 12.75C25.5 15.2448 24.7718 17.5638 23.5351 19.5287L34 29.9937L29.9937 34ZM12.75 22.6667C18.2169 22.6667 22.6667 18.2183 22.6667 12.75C22.6667 7.28167 18.2169 2.83333 12.75 2.83333C7.28308 2.83333 2.83333 7.28167 2.83333 12.75C2.83333 18.2183 7.28308 22.6667 12.75 22.6667Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_174_3384">
                        <rect width="34" height="34" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}
